import React, { useState } from "react";
import { Grid, Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { logoEduca } from "../../assets";
import { Chatbot } from "../../components/Chatbot/Chatbot";
import { EducamakerStatusBanner } from "../../components/Shared";
import {
  AdminMenu,
  Logout,
  LanguageSwitcher,
} from "../../components/Admin/AdminLayout";
import { AppSidebar } from "../../ui/components/AppSidebar";
import { NEW_SHELL } from "../../ui/featureFlags";

import "./AdminLayout.scss";
import "./AppShell.scss";

const { useBreakpoint } = Grid;

export function AdminLayout({ children }) {
  return NEW_SHELL ? (
    <ShellAdminLayout>{children}</ShellAdminLayout>
  ) : (
    <LegacyAdminLayout>{children}</LegacyAdminLayout>
  );
}

/* ---------- App Shell nuevo (F1) ---------- */
function ShellAdminLayout({ children }) {
  const screens = useBreakpoint();
  const isTablet = screens.md && !screens.lg; // 768-991: solo iconos
  const isMobile = !screens.md; // <768: drawer
  const [drawerOpen, setDrawerOpen] = useState(false);

  const cls = `app-shell ${isTablet ? "is-tablet" : ""} ${
    isMobile ? "is-mobile" : ""
  }`;

  return (
    <div className={cls}>
      {!isMobile && (
        <aside className="app-shell__sider">
          <AppSidebar collapsed={isTablet} />
        </aside>
      )}

      <Drawer
        placement="left"
        open={isMobile && drawerOpen}
        onClose={() => setDrawerOpen(false)}
        closable={false}
        className="app-shell__drawer"
        styles={{
          wrapper: { width: 280 },
          body: {
            padding: 0,
            background: "var(--edu-color-sidebar-bg, #0e0e12)",
          },
        }}
      >
        <AppSidebar onNavigate={() => setDrawerOpen(false)} />
      </Drawer>

      <div className="app-shell__main">
        {/* Sin barra superior: el contenido sube y gana alto. En movil
            mantenemos solo el burger para abrir el menu (drawer). El cierre
            de sesion vive ahora al pie del AppSidebar. */}
        {isMobile && (
          <header className="app-shell__header">
            <Button
              type="text"
              aria-label="Abrir menu"
              className="app-shell__burger"
              icon={<MenuOutlined style={{ fontSize: 20 }} />}
              onClick={() => setDrawerOpen(true)}
            />
          </header>
        )}
        {/* EducaMaker P4: franja de gracia/corte bajo el header (4.2) */}
        <EducamakerStatusBanner />
        <main className="app-shell__content">{children}</main>
      </div>

      <Chatbot />
    </div>
  );
}

/* ---------- Layout legacy (Semantic UI) ---------- */
function LegacyAdminLayout({ children }) {
  return (
    <div className="admin-layout">
      <div className="admin-layout__left">
        <div className="admin-layout__left-content">
          <img src={logoEduca.logoE360} alt="logoE360" className="logo" />
          <AdminMenu />
        </div>
      </div>

      <div className="admin-layout__right">
        <div className="admin-layout__right-header">
          <LanguageSwitcher />
          <Logout />
        </div>
        {/* EducaMaker P4: franja de gracia/corte bajo el header (4.2) */}
        <EducamakerStatusBanner />
        <div className="admin-layout__right-content">{children}</div>
      </div>

      <Chatbot />
    </div>
  );
}
